import ModalContent from '@/components/ui/Modal/ModalContent';
import Filter from '@/components/ui/Filter/Filter';
import { SelectorItem, FilterItem } from '@/components/ui/Filter/types';
import FilterShimmer from '../SearchShimmer/FilterShimmer';
import { useMemo } from 'react';

export type PracticeAreaModalProps = {
  items: FilterItem<SelectorItem>[];
  onSave?: () => void;
  onClearAllFilters?: () => void;
  onDismissButtonPress?: () => void;
  onBack?: () => void;
  onValueChanged?: (value?: string, checked?: boolean) => void;
  isLoading?: boolean;
  fetching?: boolean;
  shouldDismissButtonClose?: boolean;
  content?: {
    saveButtonLabel?: string;
    dismissButtonLabel?: string;
    title?: string;
    subheading?: string;
  };
  allowSections?: boolean;
  isSubmitLoading?: boolean;
};

const PracticeAreaModal = ({
  items,
  onSave,
  onClearAllFilters,
  onDismissButtonPress,
  onBack,
  onValueChanged,
  isLoading,
  fetching,
  shouldDismissButtonClose = false,
  content: _content,
  allowSections,
  isSubmitLoading
}: PracticeAreaModalProps): JSX.Element => {
  const content = useMemo(
    () => ({
      ..._content,
      title: _content?.title || 'Practice areas',
      dismissButtonLabel: _content?.dismissButtonLabel || 'Clear all filters',
      saveButtonLabel: _content?.saveButtonLabel || 'Save changes'
    }),
    [_content]
  );

  return (
    <ModalContent
      title={content.title}
      subtitle={content.subheading}
      saveButtonLabel={content.saveButtonLabel}
      dismissButtonLabel={content.dismissButtonLabel}
      isMultiStep={true}
      shouldDismissButtonClose={shouldDismissButtonClose}
      onDismissButtonPress={onDismissButtonPress ?? onClearAllFilters}
      onSaveButtonPress={onSave}
      onBackButtonPress={onBack}
      isSubmitLoading={isSubmitLoading}
      data-component="PracticeAreaModal"
    >
      {isLoading ? (
        <FilterShimmer type="select" />
      ) : (
        <Filter
          collapsible={false}
          type="select"
          items={items}
          groupTypeId=""
          onValueChange={onValueChanged}
          fetching={fetching}
          visibleCount
          allowSections={allowSections}
        />
      )}
    </ModalContent>
  );
};

export default PracticeAreaModal;
